import ExportModal, {
  ExportModalProps,
} from 'components/Modals/ExportModal/ExportModal'
import { createExportColumnHelper } from 'components/DataExpansionComponents/Common/commonColumnHelpers'
import { UNMATCHED_DOORS_COLUMNS } from './UnmatchedDoorsColumnsInfo'
import { COMMON_COLUMNS } from '../Common/CommonColumnsInfo'

interface UnmatchedExportModalProps extends ExportModalProps {
  subCategoryId: number
}

export function UnmatchedExportModal(props: UnmatchedExportModalProps) {
  const unmatchedColumnHelper = createExportColumnHelper({
    columns: { ...UNMATCHED_DOORS_COLUMNS, ...COMMON_COLUMNS },
  })

  const columns = [
    {
      title: 'Door Attributes',
      elements: [
        unmatchedColumnHelper.retrieveColumn('name'),
        unmatchedColumnHelper.retrieveColumn('domain'),
        unmatchedColumnHelper.retrieveColumn('address'),
        unmatchedColumnHelper.retrieveColumn('city'),
        unmatchedColumnHelper.retrieveColumn('state'),
        unmatchedColumnHelper.retrieveColumn('zipcode'),
        unmatchedColumnHelper.retrieveColumn('country'),
        unmatchedColumnHelper.retrieveColumn('phone_number'),
        unmatchedColumnHelper.retrieveColumn('extension'),
        ['created', 'Created Date'],
      ],
    },
    {
      title: 'Chain Attributes',
      elements: [
        ['chain_proxy.name', 'Parent Company'],
        ['chain_proxy.taglist', 'Chain Tags'],
        ['chain_proxy.distributors', 'Chain Distributors'],
        ['chain_proxy.gpos', 'Chain GPOs'],
        unmatchedColumnHelper.retrieveColumn('chain_size'),
      ],
    },
    {
      title: 'Account Details',
      elements: [
        ['chain_proxy.campaigns', 'Campaigns'],
        // TODO: Uncomment this when we have a better way to handle deal counts
        // unmatchedColumnHelper.retrieveColumn('deal_count'),
        ['deals.sales_stages', 'Sales Stages'],
        ['deals.account_owners', 'Account Owners'],
        ['taglist', 'Door Tags'],
        ['distributors', 'Door Distributors'],
        ['gpos', 'Door GPOs'],
        unmatchedColumnHelper.retrieveColumn('note_count'),
      ],
    },
  ]

  // Use subCategoryId for the endpoint argument
  const endpointArg = `sub_category_id:${props.subCategoryId}`

  return (
    <ExportModal
      title="Select Columns for Unmatched Doors Download"
      subTitle="Download up to 10,000 Unmatched Doors at a time, with any of the following columns. Any filters already applied will remain active."
      submitText="Export Unmatched Doors"
      columns={columns}
      endpointArgs={[endpointArg]}
      {...props}
    />
  )
}
